import { defineStyle, defineSlotRecipe } from '@chakra-ui/react';

const baseStyleField = defineStyle({
  backgroundColor: 'surface.input',
  border: '1px solid',
  borderColor: 'border.secondary',
  borderRadius: 'md',
  minHeight: 'controlHeight',
  py: '2',
  px: '3',
  color: 'text.primary',
  display: 'block',
  width: '100%',
  transitionProperty: 'common',
  transitionDuration: 'normal',
  resize: 'vertical',

  _placeholder: {
    color: 'text.placeholder',
    opacity: 1,
  },
  _hover: {
    borderColor: 'border.tertiary',
  },
  _focusVisible: {
    borderColor: 'border.action',
    boxShadow: `0 0 0 1px var(--chakra-colors-border-action)`,
    zIndex: 1,
  },
  _disabled: {
    opacity: 0.6,
    cursor: 'not-allowed',
    borderColor: 'border.secondary',
    backgroundColor: 'surface.disabled',
  },
});

export const textareaRecipe = defineSlotRecipe({
  slots: [ "field", "addon", "element" ],
  base: {
    field: baseStyleField,
  },
  variants: {
    size: {
      sm: {
        field: {
          minHeight: 'controlHeightSm',
          py: '1',
          px: '2',
          fontSize: 'sm',
        },
      },
      md: {},
      lg: {
        field: {
          minHeight: 'controlHeightLg',
          py: '2.5',
          px: '4',
          fontSize: 'lg',
        },
      },
    },
  },
  defaultVariants: {
    size: 'md',
  },
});
